import classNames from 'classnames'
import { ReactNode } from 'react'
import { IconFa, Text, TextProps } from '../../atoms'

export const CustomDisclosureWithButton = ({
  children,
  text,
  setIsOpen,
  isOpen,
  buttonTextProps,
  buttonClassName
}: {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  buttonTextProps?: Omit<TextProps, 'children'>
  text: ReactNode
  children: ReactNode
  buttonClassName?: string
}) => {
  return (
    <div className="w-full">
      <>
        <button type="button" className={classNames('w-full', buttonClassName)} onClick={() => setIsOpen(!isOpen)}>
          <Text textType="lg" className="ml-2" as="h3" {...buttonTextProps}>
            <IconFa icon={['far', isOpen ? 'chevron-down' : 'chevron-right']} className="mr-2 w-4" />
            {text}
          </Text>
        </button>

        {isOpen && <div className="mt-2">{children}</div>}
      </>
    </div>
  )
}
